import { NAV_LIST } from '@/constants';
import { cx } from '@/lib/utils';
import type { Route } from 'next';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

export const Navbar = () => {
  const pathname = usePathname();

  return (
    <nav aria-label="Main navigation" className="ml-auto hidden h-auto items-center justify-end md:flex">
      <ul className="flex items-center space-x-5 pr-8 uppercase">
        {NAV_LIST.map((nav) => {
          const isActive = nav.href === pathname;

          return (
            <li
              key={nav.key}
              className={cx(
                'link-underline link-underline-black flex items-center justify-end text-[22px] text-brand',
                isActive ? 'font-bold opacity-100' : 'opacity-70',
              )}
            >
              <Link href={nav.href as Route}>{nav.label}</Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
